import { render, staticRenderFns } from "./RichNumber.vue?vue&type=template&id=25ebd726"
import script from "./RichNumber.vue?vue&type=script&lang=js"
export * from "./RichNumber.vue?vue&type=script&lang=js"
import style0 from "./RichNumber.vue?vue&type=style&index=0&id=25ebd726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports